import React from 'react';
import Header from '../components/layout/Header';
import Footer from '../components/layout/Footer';
import Hero from '../components/sections/Hero';
import Features from '../components/sections/Features';
import PropertyGrid from '../components/sections/PropertyGrid';
import AboutSection from '../components/sections/AboutSection';
import NewsSection from '../components/sections/NewsSection';
import Contact from '../components/sections/Contact';

const Home: React.FC = () => {
  return (
    <div className="min-h-screen bg-white font-sans text-slate-900">
      <Header />
      <main>
        <Hero />
        <Features />
        <AboutSection />
        <PropertyGrid />
        <NewsSection />
        <Contact />
      </main>
      <Footer />
    </div>
  );
};

export default Home;
